import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/loan-resource'

const LoanResourceApi = {
  getWorkQueueItem (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/load-by-page`,
      input,
      success,
      failure
    )
  },

  getWorkQueueCount (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/work-queue/count`,
      input,
      success,
      failure
    )
  },

  listTimeLineByLoanId (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/timeline/list`,
      data,
      success,
      failure
    )
  },

  getLoanHistoryByParentLoanId (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/slave-loan/list`,
      input,
      success,
      failure
    )
  },

  createRequestCode (data, success, failure) {
    return ajax.post(
      `${BASE_URL}/create-request-code`,
      data,
      success,
      failure
    )
  },

  getRequestStatus (data, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-request-status`,
      data,
      success,
      failure
    )
  },

  getMultipleReportDetails (data, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-multiple-report`,
      data,
      success,
      failure
    )
  },

  getLeadProviderByLoanId (data, success, failure) {
    return ajax.get(
      `${BASE_URL}/lead-provider/get`,
      data,
      success,
      failure
    )
  },
  getProviderList (data, success, failure) {
    return ajax.get(
        `${BASE_URL}/list-ibv-provider`,
        data,
        success,
        failure
    )
  }
}
export { LoanResourceApi }
